import request from '../../utils/request';
import { Search } from '@/DTOS/TimeKeeperDevice/Search';

const TimeKeeperDeviceService = {
  search: (search: Search) => {
    return request('/timeKeeperDevice/search', {
      method: 'POST',
      body: JSON.stringify({ request: { ...search } }),
    });
  },

  upsert: (
    /** @type {any} */ id: any,
    /** @type {{ timeKeeperSystemTypeId: any; name: any; type: any; channel: any;  }} */
    formData: {
      timeKeeperSystemTypeId: any;
      name: any;
      type: any;
      channel: any;
    }
  ) => {
    return request('/timeKeeperDevice/upsert', {
      method: 'POST',
      body: JSON.stringify({
        request: {
          id: id,
          timeKeeperSystemTypeId: formData.timeKeeperSystemTypeId,
          name: formData.name,
          type: formData.type,
          channel: formData.channel,
        },
      }),
    });
  },
};

export default TimeKeeperDeviceService;
